/** Shared components and client-side errors that any screen can show. */
export default {
    errors: {
        network: 'Could not reach the server. Check your connection and try again.',
        validation: 'Validation failed',
    },
    toast: {
        dismiss: 'Dismiss notification',
    },
    localeTabs: {
        edit: 'Edit {locale}',
        default: 'default',
    },
    richText: {
        bold: 'Bold (Ctrl+B)',
        italic: 'Italic (Ctrl+I, em)',
        underline: 'Underline (Ctrl+U)',
        strike: 'Strikethrough',
        paragraph: 'Paragraph',
        heading2: 'Heading 2',
        heading3: 'Heading 3',
        bulletList: 'Bullet list',
        orderedList: 'Numbered list',
        blockquote: 'Block quote',
        link: 'Link',
        linkPrompt: 'Link URL',
        insertImage: 'Insert image',
        uploadFailed: 'Image upload failed.',
    },
    access: {
        label: 'Who can see this',
        thing: {
            page: 'this page',
            article: 'this article',
            product: 'this product',
            menuEntry: 'this menu entry',
        },
        needsCustomers: "Restricting {thing} needs customer accounts. Enable the {module} module on the website's Modules tab first.",
        customersModule: 'Customers',
        loadingGroups: 'Loading groups…',
        loadFailed: 'Could not load customer groups.',
        noGroups: 'No customer groups yet. Create one under {path}.',
        groupsPath: 'Customers → Groups',
        memberCount: '{n} members | {n} member | {n} members',
        pickGroup: 'Pick at least one group. With none selected {thing} would be visible to nobody.',
        restrictedNote: 'Restricted content stays out of menus, listings and the sitemap, and is never cached for other visitors. Visitors who are not logged in are sent to the login page.',
    },
    storage: {
        title: 'Storage',
        ofQuota: 'of {quota}',
        noQuota: 'no quota',
        critical: 'Almost full. New uploads and backups will be refused once the quota is reached.',
        warn: 'Getting full. Consider removing unused media or raising the quota.',
        notCounted: '(not counted)',
        onDisk: '{size} on disk in total.',
        measured: 'Media, renditions and backups are live; the rest was last measured {date}.',
        notMeasured: 'Themes, attachments and cache have not been measured yet: that runs nightly.',
        quotaLabel: 'Quota (GB)',
        quotaHint: 'Leave empty for no limit. Counts media, video renditions, backups, review photos, form attachments and theme versions, not the regenerable image cache.',
        quotaReadOnly: 'Quota is {quota}. Only a super admin can change it.',
    },
    upload: {
        sending: 'Sending',
        processing: 'Processing',
        finishing: 'Finishing',
        transcodingHint: 'Converting to a format every browser can play. Large videos take a few minutes.',
        renditionsHint: 'Making smaller versions for phones and slow connections.',
    },
    rejectedFields: {
        title: 'Saved, but {n} field was not stored. | Saved, but {n} fields were not stored.',
        partly: '(partly saved)',
        dismiss: 'Dismiss',
    },
};
